import React from 'react';
import { Navigation } from '../components/Navigation';
import { StrategySection } from '../components/StrategySection';
import { AcquisitionCriteriaSection } from '../components/AcquisitionCriteriaSection';
import { OperationalPlaybookSection } from '../components/OperationalPlaybookSection';
import { Footer } from '../components/Footer';
export function StrategyPage() {
  return <div className="min-h-screen bg-[#0f2424] text-white selection:bg-[#4fd1c5] selection:text-[#0f2424]" data-id="element-311">
      <Navigation data-id="element-312" />
      <main className="pt-20" data-id="element-313">
        <StrategySection data-id="element-314" />
        <AcquisitionCriteriaSection data-id="element-315" />
        <OperationalPlaybookSection data-id="element-316" />
      </main>
      <Footer data-id="element-317" />
    </div>;
}